import { render } from "./Opcoes.vue?vue&type=template&id=75565979"
import script from "./Opcoes.vue?vue&type=script&lang=js"
export * from "./Opcoes.vue?vue&type=script&lang=js"

import "./Opcoes.vue?vue&type=style&index=0&id=75565979&lang=css"

import exportComponent from "F:\\Projetos-Lefisc\\front-end\\front_retfont\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__